import { z } from "zod";

export const ValidationErrorResponse = z.object({
    code: z.number(),
    success: z.boolean(),
    message: z.string(),
    errors: z.record(
        z.string(),
        z.array(
            z.object({
                path: z.array(z.string()),
                message: z.string(),
            })
        )
    ),
});

export type ValidationErrorResponseData = z.infer<typeof ValidationErrorResponse>;
